import instance from "./axiosConfig";
import { LoginRequest } from "../DTO/LoginRequest";

export const useTareasStore = () => {
  const obtenerTareas = async (
    nombreFilter: string | null,
    fechaFilter: string | null,
    completadaFilter: boolean | null,
    categoriaId: string | null,
    limit: number
  ) => {
    try {
      const response = await instance.get("/tarea", {
        params: {
          nombre: nombreFilter,
          fecha: fechaFilter,
          completada: completadaFilter,
          categoriaId: categoriaId,
          limit: limit,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener tareas:", error);
      throw error;
    }
  };

  const obtenerTareasCompletadas = async (
  ) => {
    try {
      const response = await instance.get("/tarea/completadas");
      return response.data;
    } catch (error) {
      console.error("Error al obtener tareas completadas:", error);
      throw error;
    }
  }
  const exportarEnPdf = async (
    nombreFilter: string | null,
    fechaFilter: string | null,
    categoriaId: string | null,
    completadaFilter: boolean | null,
    limit: number
  ) => {
    try {
      // 'blob' para decirle
      //    a Axios que espere datos binarios (un archivo)
      const response = await instance.get("/tarea/pdf", {
        responseType: "blob",
        params: {
          nombre: nombreFilter,
          fecha: fechaFilter === "" ? null : fechaFilter,
          completada: completadaFilter,
          categoriaId: categoriaId,
          limit: limit,
        },
      });
      // 2. Creamos un objeto URL a partir del blob recibido (el PDF)
      //    Esto crea una URL temporal que apunta al archivo en memoria
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // 3. Creamos un elemento <a> (enlace) en el DOM
      const link = document.createElement("a");
      // 4. Asignamos al href del enlace la URL del blob (archivo PDF)
      link.href = url;
      // 5. Configuramos el atributo 'download' para sugerir al navegador
      //    que al hacer clic descargue el archivo con el nombre "tareas.pdf"
      link.setAttribute(
        "download",
        "tareas_" + new Date().toISOString().split("T")[0] + ".pdf"
      );
      // 6. Añadimos el enlace al documento para que exista en el DOM
      document.body.appendChild(link);
      // 7. Simulamos el clic sobre el enlace para iniciar la descarga automáticamente
      link.click();
      // 8. Removemos el enlace del DOM porque ya no es necesario
      link.remove();
      // 9. Liberamos la URL creada para liberar memoria
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // 10. Si algo falla en el proceso, mostramos el error en consola
      console.error("Error al exportar el PDF", error);
      throw error;
    }
  };

  const loginApp = async (loginData: LoginRequest) => {
    try {
      const response = await instance.post("/login", loginData);
      return response.data;
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error;
    }
  };

  const exportarEnExcel = async (
    nombreFilter: string | null,
    fechaFilter: string | null,
    categoriaId: string | null,
    completadaFilter: boolean | null,
    limit: number
  ) => {
    try {
      // 'blob' para decirle
      //    a Axios que espere datos binarios (un archivo)
      const response = await instance.get("/tarea/excel", {
        responseType: "blob",
        params: {
          nombre: nombreFilter,
          fecha: fechaFilter === "" ? null : fechaFilter,
          completada: completadaFilter,
          categoriaId: categoriaId,
          limit: limit,
        },
      });
      // 2. Creamos un objeto URL a partir del blob recibido (el PDF)
      //    Esto crea una URL temporal que apunta al archivo en memoria
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // 3. Creamos un elemento <a> (enlace) en el DOM
      const link = document.createElement("a");
      // 4. Asignamos al href del enlace la URL del blob (archivo PDF)
      link.href = url;
      // 5. Configuramos el atributo 'download' para sugerir al navegador
      //    que al hacer clic descargue el archivo con el nombre "tareas.pdf"
      link.setAttribute(
        "download",
        "tareas_" + new Date().toISOString().split("T")[0] + ".xlsx"
      );
      // 6. Añadimos el enlace al documento para que exista en el DOM
      document.body.appendChild(link);
      // 7. Simulamos el clic sobre el enlace para iniciar la descarga automáticamente
      link.click();
      // 8. Removemos el enlace del DOM porque ya no es necesario
      link.remove();
      // 9. Liberamos la URL creada para liberar memoria
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // 10. Si algo falla en el proceso, mostramos el error en consola
      console.error("Error al exportar el excel", error);
      throw error;
    }
  };

  const obtenerTareasbyId = async (id: string | null) => {
    if (!id) {
      console.warn("ID inválido:", id);
      return null;
    }

    try {
      const response = await instance.get("/tarea/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al obtener la tarea:", error);
      throw error;
    }
  };

  const eliminarTarea = async (id: number) => {
    try {
      const response = await instance.delete("/tarea/eliminar/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al eliminar la tarea:", error);
      throw error;
    }
  };

  const creatTarea = async (
    id: number | null,
    nombre: string,
    descripcion: string,
    categoriaId: number | null,
    fecha: string,
    hora: string,
    completada: boolean,
    aviso: boolean,
    fechaHoraAvisoPersonalizado: string | null
  ) => {
    try {
      const response = await instance.post("/tarea/agregar", {
        id,
        nombre,
        descripcion,
        categoriaId: categoriaId,
        fecha,
        hora,
        completada,
        aviso,
        fechaHoraAvisoPersonalizado,
      });

      return response.data;
    } catch (error) {
      console.error("Error al eliminar la tarea:", error);
      throw error;
    }
  };

  return {
    obtenerTareas,
    eliminarTarea,
    creatTarea,
    obtenerTareasbyId,
    exportarEnPdf,
    exportarEnExcel,
    loginApp,
    obtenerTareasCompletadas,
  };
};
